import { render, staticRenderFns } from "./MDashboardWidget.vue?vue&type=template&id=0cc35865&scoped=true&lang=pug&"
import script from "./MDashboardWidget.vue?vue&type=script&lang=ts&"
export * from "./MDashboardWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc35865",
  null
  
)

export default component.exports